import getModuleContextMailboxInfo from 'owa-module-context-mailboxinfo/lib/selectors/getModuleContextMailboxInfo';
import isPopout from 'owa-popout-v2/lib/utils/isPopout';
import { isChatEnabled } from '../isChatEnabled';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { getCurrentModule } from 'owa-app-module-store';
import { Module } from 'owa-workloads-module';
import { logUsage } from 'owa-analytics';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import { type MailboxInfo } from 'owa-client-types';

/**
 * Don't show Chat if license is not enabled or if in a popout.
 * The popout is because currently Copilot Chat pane only appears on the main window.
 * For mail popouts, Chat is only enabled in reading pane scenarios (not compose).
 */
export function shouldShowChatMenuItem(
    shouldIgnoreUserPreferences: boolean,
    targetWindow: Window,
    mailboxInfo: MailboxInfo = getModuleContextMailboxInfo()
): boolean {
    const isConsumerCalendar =
        isConsumer(undefined /* smtpAddress */, mailboxInfo) &&
        getCurrentModule() === Module.Calendar;
    const isPopoutWindow = isPopout(targetWindow);
    const chatEnabled = isChatEnabled(mailboxInfo, shouldIgnoreUserPreferences);
    const showChatMenuItem =
        (isGlobalFeatureEnabled('mon-copilot-bizchat-popout') || !isPopoutWindow) &&
        !isConsumerCalendar &&
        chatEnabled;

    if (!showChatMenuItem && chatEnabled) {
        logUsage('OutlookCopilotChat_ChatMenuItemNotShown', mailboxInfo, {
            chatEnabled,
            isPopoutWindow,
            isConsumerCalendar,
        });
    }
    return showChatMenuItem;
}
